/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  InventoryStockPosition,
  InventoryStockPositionInput,
  InventoryStockPositionsList,
  SchemaValidationErrorResponse,
  StandardError,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Vehicle Inventory Stock
 */
export const vehicleInventoryStock = (
    vehicleId: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      vehicleId = toValue(vehicleId);

      return axiosClient<InventoryStockPositionsList>(
      {url: `/vehicles/${vehicleId}/inventory/stock`, method: 'GET', signal
    },
      );
    }




export const getVehicleInventoryStockQueryKey = (vehicleId: MaybeRefOrGetter<string>,) => {
    return [
    'vehicles',vehicleId,'inventory','stock'
    ] as const;
    }


export const getVehicleInventoryStockQueryOptions = <TData = Awaited<ReturnType<typeof vehicleInventoryStock>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(vehicleId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vehicleInventoryStock>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getVehicleInventoryStockQueryKey(vehicleId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vehicleInventoryStock>>> = ({ signal }) => vehicleInventoryStock(vehicleId, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(vehicleId) !== null && toValue(vehicleId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vehicleInventoryStock>>, TError, TData>
}

export type VehicleInventoryStockQueryResult = NonNullable<Awaited<ReturnType<typeof vehicleInventoryStock>>>
export type VehicleInventoryStockQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Vehicle Inventory Stock
 */

export function useVehicleInventoryStock<TData = Awaited<ReturnType<typeof vehicleInventoryStock>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 vehicleId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vehicleInventoryStock>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVehicleInventoryStockQueryOptions(vehicleId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Vehicle Inventory Stock Position
 */
export const vehicleInventoryStockItem = (
    vehicleId: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      vehicleId = toValue(vehicleId);
slug = toValue(slug);

      return axiosClient<InventoryStockPosition>(
      {url: `/vehicles/${vehicleId}/inventory/stock/${slug}`, method: 'GET', signal
    },
      );
    }




export const getVehicleInventoryStockItemQueryKey = (vehicleId: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,) => {
    return [
    'vehicles',vehicleId,'inventory','stock',slug
    ] as const;
    }


export const getVehicleInventoryStockItemQueryOptions = <TData = Awaited<ReturnType<typeof vehicleInventoryStockItem>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(vehicleId: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vehicleInventoryStockItem>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getVehicleInventoryStockItemQueryKey(vehicleId,slug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vehicleInventoryStockItem>>> = ({ signal }) => vehicleInventoryStockItem(vehicleId,slug, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(vehicleId) !== null && toValue(vehicleId) !== undefined && toValue(slug) !== null && toValue(slug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vehicleInventoryStockItem>>, TError, TData>
}

export type VehicleInventoryStockItemQueryResult = NonNullable<Awaited<ReturnType<typeof vehicleInventoryStockItem>>>
export type VehicleInventoryStockItemQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Vehicle Inventory Stock Position
 */

export function useVehicleInventoryStockItem<TData = Awaited<ReturnType<typeof vehicleInventoryStockItem>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 vehicleId: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vehicleInventoryStockItem>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVehicleInventoryStockItemQueryOptions(vehicleId,slug,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update Vehicle Inventory Stock Position
 */
export const updateVehicleInventoryStockItem = (
    vehicleId: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,
    inventoryStockPositionInput: MaybeRefOrGetter<InventoryStockPositionInput>,
 signal?: AbortSignal
) => {
      vehicleId = toValue(vehicleId);
slug = toValue(slug);
inventoryStockPositionInput = toValue(inventoryStockPositionInput);

      return axiosClient<InventoryStockPosition>(
      {url: `/vehicles/${vehicleId}/inventory/stock/${slug}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: inventoryStockPositionInput, signal
    },
      );
    }




export const getUpdateVehicleInventoryStockItemMutationKey = () => ['updateVehicleInventoryStockItem'] as const;

export const getUpdateVehicleInventoryStockItemMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVehicleInventoryStockItem>>, TError,UpdateVehicleInventoryStockItemMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateVehicleInventoryStockItem>>, TError,UpdateVehicleInventoryStockItemMutationVariables, TContext> => {

const mutationKey = getUpdateVehicleInventoryStockItemMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateVehicleInventoryStockItem>>, UpdateVehicleInventoryStockItemMutationVariables> = (props) => {
          const {vehicleId,slug,data} = props ?? {};

          return  updateVehicleInventoryStockItem(vehicleId,slug,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateVehicleInventoryStockItemMutationResult = NonNullable<Awaited<ReturnType<typeof updateVehicleInventoryStockItem>>>
    export type UpdateVehicleInventoryStockItemMutationBody = InventoryStockPositionInput
    export type UpdateVehicleInventoryStockItemMutationError = ErrorType<ValidationError | StandardError>
    export type UpdateVehicleInventoryStockItemMutationVariables = {vehicleId: string;slug: string;data: InventoryStockPositionInput}

    /**
 * @summary Update Vehicle Inventory Stock Position
 */
export const useUpdateVehicleInventoryStockItem = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVehicleInventoryStockItem>>, TError,UpdateVehicleInventoryStockItemMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateVehicleInventoryStockItem>>,
        TError,
        UpdateVehicleInventoryStockItemMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateVehicleInventoryStockItemMutationOptions(options), queryClient);
    }
    /**
 * @summary Delete Vehicle Inventory Stock Position
 */
export const destroyVehicleInventoryStockItem = (
    vehicleId: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      vehicleId = toValue(vehicleId);
slug = toValue(slug);

      return axiosClient<void>(
      {url: `/vehicles/${vehicleId}/inventory/stock/${slug}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyVehicleInventoryStockItemMutationKey = () => ['destroyVehicleInventoryStockItem'] as const;

export const getDestroyVehicleInventoryStockItemMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyVehicleInventoryStockItem>>, TError,DestroyVehicleInventoryStockItemMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyVehicleInventoryStockItem>>, TError,DestroyVehicleInventoryStockItemMutationVariables, TContext> => {

const mutationKey = getDestroyVehicleInventoryStockItemMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyVehicleInventoryStockItem>>, DestroyVehicleInventoryStockItemMutationVariables> = (props) => {
          const {vehicleId,slug} = props ?? {};

          return  destroyVehicleInventoryStockItem(vehicleId,slug,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyVehicleInventoryStockItemMutationResult = NonNullable<Awaited<ReturnType<typeof destroyVehicleInventoryStockItem>>>

    export type DestroyVehicleInventoryStockItemMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type DestroyVehicleInventoryStockItemMutationVariables = {vehicleId: string;slug: string}

    /**
 * @summary Delete Vehicle Inventory Stock Position
 */
export const useDestroyVehicleInventoryStockItem = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyVehicleInventoryStockItem>>, TError,DestroyVehicleInventoryStockItemMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyVehicleInventoryStockItem>>,
        TError,
        DestroyVehicleInventoryStockItemMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyVehicleInventoryStockItemMutationOptions(options), queryClient);
    }
